module.exports = __webpack_public_path__ + "static/work-projects-1-ba15ad629f925c632a87db44ce3b5eb2.jpg";